import { type MutationError, trpc } from '@/shared/api';

interface UseRenamePrintMethodOptions {
  readonly onSuccess?: () => void;
}

/** 인쇄 방식 이름 수정 — 사용 중인 방식도 이름은 고칠 수 있다. */
export const useRenamePrintMethod = ({ onSuccess }: UseRenamePrintMethodOptions = {}) => {
  const mutation = trpc.productManagement.printMethods.update.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    renamePrintMethod: mutation.mutate,
    /** 저장이 진행 중인 인쇄 방식 id — 진행 표시를 해당 행에만 스코프한다. */
    pendingId: mutation.isPending ? (mutation.variables?.id ?? null) : null,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
